import { render, staticRenderFns } from "./ButtonGroupView.vue?vue&type=template&id=07f924f2&scoped=true&"
import script from "./ButtonGroupView.vue?vue&type=script&lang=js&"
export * from "./ButtonGroupView.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGroupView.vue?vue&type=style&index=0&id=07f924f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f924f2",
  null
  
)

export default component.exports